import { isEmpty } from 'remeda'
import type { ProductMedia, Slide, SlideModel } from '@velasca/types'

interface Thumbnails {
  visuals: {
    mobile: Slide[]
    desktop: Slide[]
  }
  still_life: Slide[]
  model?: SlideModel
}

interface RawProductMedia {
  images: Thumbnails
  thumbnails: Thumbnails
}

/**
 * Takes the images of a product and return a copy of them with some transformations applied.
 *
 * @param productMedia - The object that holds the images and thumbnails of a product.
 */
export const transformProductMedia = (
  productMedia: RawProductMedia,
  isMobile: boolean,
): ProductMedia => {
  const hasMobilePhotos = !isEmpty(productMedia.images.visuals.mobile)
  const mediaKey = isMobile && hasMobilePhotos ? 'mobile' : 'desktop'

  const transformedProductMedia: ProductMedia = {
    slides: [
      ...productMedia.images.still_life,
      ...(productMedia.images.model?.id ? [productMedia.images.model] : []),
      ...productMedia.images.visuals[mediaKey],
    ],
    thumbnails: [
      ...productMedia.thumbnails.still_life,
      ...(productMedia.thumbnails.model?.id
        ? [productMedia.thumbnails.model]
        : []),
      ...productMedia.thumbnails.visuals[mediaKey],
    ],
  }

  return transformedProductMedia
}
